import { isToday, isYesterday, startOfWeek, endOfWeek, isWithinInterval, subWeeks } from 'date-fns'

import type { NotificationGroup } from 'src/shared/schemas/stream'

export const groupNotificationsByTimeframe = (groups: NotificationGroup[]) => {
  const today: NotificationGroup[] = []
  const yesterday: NotificationGroup[] = []
  const thisWeek: NotificationGroup[] = []
  const lastWeek: NotificationGroup[] = []
  const history: NotificationGroup[] = []

  const now = new Date()
  const currentWeekStart = startOfWeek(now)
  const currentWeekEnd = endOfWeek(now)
  const lastWeekStart = startOfWeek(subWeeks(now, 1))
  const lastWeekEnd = endOfWeek(subWeeks(now, 1))

  groups.forEach((group) => {
    const date = new Date(group.updatedAt)

    if (isToday(date)) {
      today.push(group)
    } else if (isYesterday(date)) {
      yesterday.push(group)
    } else if (
      isWithinInterval(date, {
        start: currentWeekStart,
        end: currentWeekEnd,
      })
    ) {
      thisWeek.push(group)
    } else if (
      isWithinInterval(date, {
        start: lastWeekStart,
        end: lastWeekEnd,
      })
    ) {
      lastWeek.push(group)
    } else {
      history.push(group)
    }
  })

  return [
    { title: 'Today', groups: today },
    { title: 'Yesterday', groups: yesterday },
    { title: 'Earlier this week', groups: thisWeek },
    { title: 'Last week', groups: lastWeek },
    { title: 'History', groups: history },
  ].filter((section) => section.groups.length > 0)
}
